module.exports = __webpack_public_path__ + "static/media/upgrade-vps-mobile.05fb36d5.png";